"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
// //
// // assets
// //
const profileCopy_1 = require("../../../../copy/profileCopy");
const queryDefinitions_1 = require("../../../../queryDefinitions");
// //
// // components
// //
const GenericInput_1 = __importDefault(require("../../../general/inputs/GenericInput"));
const PasswordInput_1 = __importDefault(require("../../../general/inputs/PasswordInput"));
const FormValidation_1 = require("../../../general/utility/FormValidation");
// //
// // styles
// //
const StyledInputContainer_1 = require("../StyledInputContainer");
const StyledInvalidFeedback_1 = require("../../StyledInvalidFeedback");
const react_bootstrap_1 = require("react-bootstrap");
const MalomoButton_1 = require("../../MalomoButton");
// eslint-disable-next-line complexity
const Profile = () => {
    const [name, setName] = (0, react_1.useState)('');
    const [email, setEmail] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [nameError, setNameError] = (0, react_1.useState)('');
    const [emailError, setEmailError] = (0, react_1.useState)('');
    const [passwordError, setPasswordError] = (0, react_1.useState)('');
    const [nameButtonStatus, setNameButtonStatus] = (0, react_1.useState)('');
    const [emailButtonStatus, setEmailButtonStatus] = (0, react_1.useState)('');
    function handleBlur(event) {
        const error = (0, FormValidation_1.validateInput)(event.target.id, event.target.value);
        if (error) {
            if (event.target.id === 'name') {
                setNameError(error);
            }
            if (event.target.id === 'email') {
                setEmailError(error);
            }
            if (event.target.id === 'password') {
                setPasswordError(error);
            }
        }
        else {
            if (event.target.id === 'name') {
                setNameError('');
            }
            if (event.target.id === 'email') {
                setEmailError('');
            }
            if (event.target.id === 'password') {
                setPasswordError('');
            }
        }
    }
    function handleInputChange(event) {
        if (event.target.id === 'name') {
            setName(event.target.value);
        }
        if (event.target.id === 'email') {
            setEmail(event.target.value);
        }
        if (event.target.id === 'password') {
            setPassword(event.target.value);
        }
    }
    const [changeUserName, { data: changeUserNameData, loading: changeUserNameLoading, error: changeUserNameError }] = (0, client_1.useMutation)(queryDefinitions_1.UPDATE_USER_NAME);
    const [changeEmail, { data: changeEmailData, loading: changeEmailLoading, error: changeEmailError }] = (0, client_1.useMutation)(queryDefinitions_1.UPDATE_USER_EMAIL);
    const { data: userData } = (0, client_1.useQuery)(queryDefinitions_1.GET_USER);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (userData) {
            setName((_a = userData.currentUser) === null || _a === void 0 ? void 0 : _a.name);
            setEmail((_b = userData.currentUser) === null || _b === void 0 ? void 0 : _b.email);
        }
    }, [userData]);
    function handleUpdateUserName() {
        setNameButtonStatus('Loading...');
        changeUserName({
            variables: {
                input: {
                    name: name
                }
            }
        });
    }
    function handleUpdateEmail() {
        setEmailButtonStatus('Loading...');
        changeEmail({
            variables: {
                input: {
                    currentPassword: password,
                    email: email
                }
            }
        });
    }
    (0, react_1.useEffect)(() => {
        if (changeUserNameData) {
            setNameButtonStatus('Success!');
            setTimeout(() => {
                setNameButtonStatus('');
            }, 5000);
        }
        if (changeUserNameError) {
            setNameButtonStatus('');
        }
        if (changeEmailData) {
            setEmailButtonStatus('Success!');
            setTimeout(() => {
                setEmailButtonStatus('');
            }, 5000);
        }
        if (changeEmailError) {
            setEmailButtonStatus('');
        }
    }, [
        changeUserNameData,
        changeUserNameError,
        changeEmailData,
        changeEmailError
    ]);
    function displayApiError(error) {
        if (error.message === 'Failed to fetch') {
            return 'The server could not be reached, please try again later';
        }
        if (error.message.includes('required')) {
            return 'All input is required, please try again';
        }
        return error.message;
    }
    return (react_1.default.createElement(react_bootstrap_1.Fade, { appear: true, in: true },
        react_1.default.createElement("div", null,
            react_1.default.createElement(StyledInputContainer_1.StyledInputContainer, null,
                react_1.default.createElement(GenericInput_1.default, { error: nameError, id: 'name', label: profileCopy_1.profileCopy.label1, onBlur: handleBlur, onInputChange: handleInputChange, value: name }),
                react_1.default.createElement(MalomoButton_1.MalomoButton, { className: changeUserNameData ? 'name-success' : '', disabled: changeUserNameLoading ? changeUserNameLoading : false, id: 'name-button', marginTopLarge: true, onClick: handleUpdateUserName, style: { minWidth: '130px' } }, nameButtonStatus ? nameButtonStatus : profileCopy_1.profileCopy.button1),
                changeUserNameError ? (react_1.default.createElement(StyledInvalidFeedback_1.StyledInvalidFeedback, { className: 'api-error invalid-feedback' }, displayApiError(changeUserNameError))) : null),
            react_1.default.createElement(StyledInputContainer_1.StyledInputContainer, null,
                react_1.default.createElement(GenericInput_1.default, { error: emailError, id: 'email', label: profileCopy_1.profileCopy.label2, onBlur: handleBlur, onInputChange: handleInputChange, value: email }),
                react_1.default.createElement(PasswordInput_1.default, { error: passwordError, id: 'password', label: profileCopy_1.profileCopy.label3, onBlur: handleBlur, onInputChange: handleInputChange, spacing: '18px' }),
                react_1.default.createElement(MalomoButton_1.MalomoButton, { className: changeEmailData ? 'email-success' : '', disabled: changeEmailLoading ? changeEmailLoading : false, id: 'email-button', marginTopLarge: true, onClick: handleUpdateEmail, style: { minWidth: '130px' } }, emailButtonStatus ? emailButtonStatus : profileCopy_1.profileCopy.button2),
                changeEmailError ? (react_1.default.createElement(StyledInvalidFeedback_1.StyledInvalidFeedback, { className: 'api-error invalid-feedback', id: 'email-button' }, displayApiError(changeEmailError))) : null),
            react_1.default.createElement("div", null))));
};
exports.default = Profile;
